// extracted by mini-css-extract-plugin
module.exports = {"places":"items-module--places--2cdG1","subText":"items-module--sub-text--1hprA","center":"items-module--center--2xKcp"};